var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Header'),_c('main',[_c('router-view')],1),_c('Modals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }